import React from 'react';
import Message from './Message';
import { t, props } from 'tcomb-react';

@props({
  children: t.Any
})
export default class ConsoleMessage extends React.Component {

  render() {
    return (<Message bgColor='#fff' fontColor='#333'>{this.props.children}</Message>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/ConsoleMessage.js
 **/